<template>
    <div>
        <div v-for="question in queued_questions" :key="question.hashid" class="bg-gradient-light text-gray-800 rounded mx-5 my-5 p-5" style="height:auto;min-height:50vh!important">
            <span style="font-size: 2rem"><span class="font-weight-bold">{{ question.name }}</span> from <span class="font-italic">{{question.company}}</span></span>
            <p style="font-size: 3rem"><nl2br tag="span" :text="question.question" class-name="" /></p>
        </div>
    </div>
</template>

<script>

    var moment = require('moment')
    moment().format()

    export default {
        name: "QuestionShow",

        props: {
            webcast_hashid: {
                type: String,
                // Object or array defaults must be returned from
                // a factory function
            },
        },
        data() {
            return {
                queued_questions:[],
                refresh_timer: null
            }
        },
        components: {
        },
        computed: {
        },
        mounted() {
            axios.get('/api/webcast/'+ this.webcast_hashid +'/queued_question').then((response) => {
                this.queued_questions = response.data.queued_questions
                this.refresh_timer = setInterval(() => {this.refresh()}, 3000)
            }).catch((error) => {
                /*Swal.fire({
                    title: 'Error',
                    text: 'Unable to retrieve record',
                    icon: 'error',
                    confirmButtonText: 'Dismiss'
                }).then((result) => {
                    //location.href='/webcast/'+this.webcast_hashid
                });*/
            });

        },
        methods: {

            moment(date) {
                return moment(date)
            },

            refresh() {
                axios.get('/api/webcast/'+ this.webcast_hashid  +'/queued_question').then((response) => {
                    this.queued_questions = response.data.queued_questions
                }).catch((error) => {
                })
            },
        }
    }

</script>

<style>
</style>
